import dayjs from "dayjs";

const formatDate = (date: string, format: string = "YYYY-MM-DD") => {
	return dayjs(date).format(format);
};

const formatMMSS = (total: number) => {
	const m = Math.floor(total / 60)
		.toString()
		.padStart(1, "0");
	const s = (total % 60).toString().padStart(2, "0");
	return `${m}:${s}`;
};
export { formatDate, formatMMSS };
